<script setup lang="ts">
import {Export} from '@/components/export/';
import { useCaseStore } from '@/stores/case';
import { useFormStore } from '@/stores/forms';
import { onMounted } from 'vue';

const caseStore = useCaseStore();
const formStore = useFormStore();

onMounted(async () => {
  await caseStore.getStudyCases(undefined, undefined, 'export');
  await formStore.getStudyForms();
});
</script>

<template>
  <div class="export-container"><Export /></div>
</template>

<style scoped lang="scss">
.export-container {
  height: 100%;
}
</style>
